import { useMemo } from "react";
import { useParamsContext } from "@/features/configuration/contexts/params-context";
import { ConfigurationKey } from "@/shared/types/configuration-keys";
import { OperationalMode, isFacturacionEnabled, isGestionEnabled } from "@/shared/types/operational-mode";

/**
 * Devuelve el modo operativo actual y flags derivados.
 * Valor por defecto: Gestión (1) si el parámetro no existe o es inválido.
 */
export function useOperationalMode() {
  const { getNumber } = useParamsContext();

  return useMemo(() => {
    const modeValue = getNumber(ConfigurationKey.OperationalMode, OperationalMode.Gestion);
    const mode = Object.values(OperationalMode).includes(modeValue as OperationalMode)
      ? (modeValue as OperationalMode)
      : OperationalMode.Gestion;

    return {
      mode,
      gestionEnabled: isGestionEnabled(mode),
      facturacionEnabled: isFacturacionEnabled(mode),
    };
  }, [getNumber]);
}
